export abstract class DocumentationRoutesConstants {
  static readonly MAIN = "documentation";
  static readonly DOCUMENT = "document";
  static readonly PUBLIC = "public";

  static readonly main = (): string => `/${DocumentationRoutesConstants.MAIN}`;
  static readonly document = (id?: string): string => {
    const base = `${DocumentationRoutesConstants.main()}/${DocumentationRoutesConstants.DOCUMENT}`;
    return id ? `${base}/${id}` : base;
  };
  static readonly publicDocument = (id: string, folderId?: string | null): string =>
    folderId
      ? `/${this.PUBLIC}/${this.MAIN}/${folderId}/${this.DOCUMENT}/${id}`
      : `/${this.PUBLIC}/${this.MAIN}/${this.DOCUMENT}/${id}`;
  static readonly publicFolder = (folderId: string): string => `/${this.PUBLIC}/${this.MAIN}/${folderId}`;
}
